import Divcard1 from "../components/Divcard1";
import Button from "../components/Button";
import Divfooter5 from "../components/Divfooter5";
import DivfooterSub from "../components/DivfooterSub";
import Navigation1 from "../components/Navigation1";
import "./WwwmontyesimcomByHtmltod6.css";
import  Card  from "../components/card";
const WwwmontyesimcomByHtmltod6 = () => {
  return (
    <div className="wwwmontyesimcom-by-htmltod6">
     <Navigation1 />
      <main className="divcolmd">
        <section className="separator-parent">
          <div className="separator1">
            <div className="frame-arrow-right-f-f-f-s-v-g">
              <div className="frame-mutluluk">
                <div className="divfooter">
                  <div className="phone-link">
                    <h1 className="heading-13">Choose your plan</h1>
                  </div>
                  <div className="europe-trio-container">
                    <div className="please1">{`Please `}</div>
                    <b className="dial-061">dial *#06#</b>
                    <div className="email">
                      <div className="parent-frame">
                        <div className="to-check-device1">
                          to check device compatibility, if EID exist then
                        </div>
                      </div>
                      <div className="your-device-is1">
                        your device is compatible
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="divcountry1">
                <div className="divcss-1s2u09g-control1">
                  <div className="divcss-ackcql" />
                  <div className="separator2">
                    <img
                      className="searchicon5548a86csvg1"
                      loading="eager"
                      alt=""
                      src="/searchicon5548a86csvg1.svg"
                    />
                    <div className="divcss-1rhbuit-multivalue">
                      <div className="divcss-12jo7m5">
                        <div className="turkey">Turkey</div>
                      </div>
                      <img
                        className="button-remove-turkey"
                        loading="eager"
                        alt=""
                        src="/button--remove-turkey.svg"
                      />
                    </div>
                  </div>
                  <img
                    className="divcss-1wy0on6-icon"
                    loading="eager"
                    alt=""
                    src="/divcss1wy0on6.svg"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="framearrowrightfffsvg-frame">
           <Card />
           <Card />
           <Card />
           <Card />
           <Card />
           <Card />
            {/* <Divcard1
              trsvg="/trsvg-2.svg"
              mutluluk="Mutluluk"
              gB="1 GB "
              arrowRight2472f8ffsvg="/arrowright2472f8ffsvg-1.svg"
              validity7Days="Validity 7 Days"
              trsvg1="/trsvg-3.svg"
              divcolMd5="/divcolmd5-1.svg"
              buyNow199USD="Buy Now - 1.99 USD"
            />
            <Divcard1
              trsvg="/trsvg-4.svg"
              mutluluk="Mutluluk (15% OFF)"
              gB="3 GB "
              arrowRight2472f8ffsvg="/arrowright2472f8ffsvg-2.svg"
              validity7Days="Validity 30 Days"
              trsvg1="/trsvg-5.svg"
              divcolMd5="/divcolmd5-2.svg"
              buyNow199USD="Buy Now - 3.99 USD"
              propPadding="0px var(--padding-6xs) 0px var(--padding-11xs)"
              propPadding1="unset"
              propPadding2="unset"
              propMinWidth="156px"
              propWidth="156px"
              propAlignSelf="stretch"
              propWidth1="90px"
              propWidth2="73.8px"
              propLeft="73px"
              propPadding3="0px var(--padding-6xs)"
              propPadding4="unset"
              propMarginLeft="unset"
              propPadding5="var(--padding-mini) 0px var(--padding-mini) var(--padding-mini)"
            /> */}
          </div>
          {/* <Button /> */}
        </section>
        <Divfooter5 />
        <DivfooterSub propPadding="var(--padding-23xl) var(--padding-207xl) var(--padding-22xl) var(--padding-292xl)" />
      </main>
    </div>
  );
};

export default WwwmontyesimcomByHtmltod6;
